import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useStateMachine } from "little-state-machine";
import { updateAction, setAction } from "../updateAction";

import "./App.css";
import Header from "../assets/images/Header.png";
import Step2 from "../assets/images/stepbar_2.png";
import Icon1 from "../assets/images/product-4l.png";
import Icon2 from "../assets/images/product-4x300.png";

const FormConfirm = (props) => {
  const { actions, state } = useStateMachine({ updateAction, setAction });

  useEffect(() => {
    if (props.history.action === "POP") {
      actions.setAction({});
      props.history.push("/entry");
    }
  }, [actions, props.history]);

  const onClickReturn = () => {
    actions.updateAction(state);
    props.history.push("/entry");
  };

  const onClickSubmit = () => {
    var URL =
      "https://script.google.com/macros/s/AKfycbwj2r7XWdpgFgE0gtp6vWK3ZDNihHpN7GoCa_Q85PlqM7CCg97DpuLwh9R-vosgdMSsLg/exec";

    var postparam = {
      method: "POST",
      mode: "no-cors",
      "Content-Type": "application/x-www-form-urlencoded",
      body: JSON.stringify(state),
    };

    fetch(URL, postparam).then((response) => {
      console.log(response);
      actions.setAction({ personalName: state.personalName });
      props.history.push("/entry/complete");
    });
  };
  return (
    <>
      <div className="layout">
        <div className="layout__content">
          <img src={Header} alt="" />

          <div className="container">
            <div className="row" style={{ alignItems: "flex-start" }}>
              <img src={Step2} alt="" className="stepbar" />
            </div>
          </div>
          <section className="con-lead">
            <div className="container">
              <div className="row">
                <div className="col_12 con_form">
                  <div className="title-header">
                    <p>ご注文商品情報入力</p>
                  </div>
                  <div className="col_12">
                    <ul className="con_product_items table_ul">
                      <li className="con_product_box">
                        <img src={Icon1} alt=""></img>
                      </li>
                      <li className="con_product_box con_product_text">
                        <span>ハンドクリーン71 4L</span>
                        <span>5,940円（税抜）</span>
                      </li>
                      <li className="con_product_box">
                        <span className="count_text">
                          {state.quantity1} セット
                        </span>
                      </li>
                    </ul>
                    <ul className="con_product_items table_ul">
                      <li className="con_product_box">
                        <img src={Icon2} alt=""></img>
                      </li>
                      <li className="con_product_box con_product_text">
                        <span>ハンドクリーン71 4L×300mL 1セット</span>
                        <span>6,500円（税抜）</span>
                      </li>
                      <li className="con_product_box">
                        <span className="count_text">
                          {state.quantity2} セット
                        </span>
                      </li>
                    </ul>
                    <ul className="con_product_items table_ul">
                      <ul className="con_form_ul__result">
                        <label className="con_form__label">
                          クーポンコード
                        </label>
                        {state.coupon}
                      </ul>
                    </ul>
                    <div className="con_product_items__sum">
                      <div className="">
                        <ul className="con_form_ul__sum">
                          <li>
                            <p className="con_product_text__text">商品小計</p>
                            <p className="con_product_text__num">
                              ¥ {state.subtotal}
                            </p>
                          </li>
                        </ul>
                        <ul className="con_form_ul__sum">
                          <li>
                            <p className="con_product_text__text">送料</p>
                            <p className="con_product_text__num">
                              ¥ {state.shipping}
                            </p>
                          </li>
                        </ul>
                        {state.coupon && (
                          <ul className="con_form_ul__sum">
                            <li>
                              <p className="con_product_text__text">値引き</p>
                              <p className="con_product_text__num">
                                ¥ {state.discount}
                              </p>
                            </li>
                          </ul>
                        )}
                        <ul className="con_form_ul__sum">
                          <li>
                            <p className="con_product_text__text">合計</p>
                            <p className="con_product_text__num">
                              ¥ {state.total}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="title-header">
                    <p>購入者情報入力</p>
                  </div>
                  <div className="col_12 con_form_box">
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        会社名/屋号
                      </label>
                      <p className="con_result_text__value">{state.company}</p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        代表者氏名
                      </label>
                      <p className="con_result_text__value">
                        {state.companyPersonalName}
                      </p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">URL</label>
                      <p className="con_result_text__value">{state.url}</p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        担当者氏名
                      </label>
                      <p className="con_result_text__value">
                        {state.personalName}
                      </p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">配送先名</label>
                      <p className="con_result_text__value">
                        {state.deliveryName}
                      </p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        配送先郵便番号
                      </label>
                      <p className="con_result_text__value">
                        {state.deliveryZipcode}
                      </p>
                    </ul>
                    <div className="con_form_li__non">
                      <label className="con_result_text__label">
                        <div style={{ display: "block", width: 300 }}>
                          配送先住所
                          <br />
                          <span style={{ fontSize: 1 }}>
                            ※ 配送先が複数ある場合は配送先ごとにご注文下さい。
                          </span>
                        </div>
                      </label>
                      <p className="con_result_text__value"></p>
                    </div>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">都道府県</label>
                      <p className="con_result_text__value">
                        {state.deliveryPref}
                      </p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        市区町村・番地
                      </label>
                      <p className="con_result_text__value">
                        {state.deliveryAddress1}
                      </p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        建物名・部屋番号
                      </label>
                      <p className="con_result_text__value">
                        {state.deliveryAddress2}
                      </p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        配送希望日
                        <span style={{ fontSize: 1, display: "block" }}>
                          ※ 6営業日以降でご希望の日付をご入力ください。
                        </span>
                      </label>
                      <p className="con_result_text__value">{state.date}</p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">電話番号</label>
                      <p className="con_result_text__value">{state.tel}</p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        メールアドレス
                      </label>
                      <p className="con_result_text__value">{state.mail}</p>
                    </ul>
                    <ul className="con_form_ul__result">
                      <label className="con_result_text__label">
                        請求書送付先メールアドレス
                        <span style={{ fontSize: 1, display: "block" }}>
                          ※ お支払い方法は請求書払いのみとなります。
                        </span>
                      </label>
                      <p className="con_result_text__value">
                        {state.mailInvoice}
                      </p>
                    </ul>
                    <div className="col_12 con_form_box btn_box">
                      <button type="" className="btn" onClick={onClickReturn}>
                        前に戻る
                      </button>
                      <button
                        type="submit"
                        className="btn"
                        onClick={onClickSubmit}
                      >
                        注文を確定する
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
export default withRouter(FormConfirm);
